import { PlusCircle } from 'lucide-react';

const UploadWidget = ({ description, onClick, enabled }) => {
    return (
        <button
            type="button"
            onClick={onClick}
            className={`
                flex-1 flex items-center justify-center space-x-2 font-semibold 
                py-2.5 rounded-lg transition-colors
                ${enabled
                    ? 'bg-blue-500 hover:bg-blue-600 text-white cursor-pointer'
                    : 'bg-slate-300 text-slate-500 cursor-not-allowed'
                }
            `}
        >
            <PlusCircle size={20} />
            <span>{description}</span>
        </button>
    )
}

export default UploadWidget;